import type { AccountModificationFlowId } from '@ctct/infrastructure-layer';
import type { ProgressBarStepId } from '@ctct/state-client-layer';

import { EventBus } from '../../helpers';

// we use type instead of interface to satisfy typescript's type checking
type PayflowProgressBarEvents = {
  goToStep: [stepId: ProgressBarStepId, flowId: AccountModificationFlowId];
};

class PayflowProgressBarEventBus extends EventBus<PayflowProgressBarEvents> {}

export const payflowProgressBarEventBus = new PayflowProgressBarEventBus();
